import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
export default (context) => {
  return {

    config: {
      pageSize: 40,
      list: false
    },

    actions: {
      create: {
        reloadGrid: true
      },
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter: {
      fields: [
        {
          name: "periodId",
          value: { value: "0", label: "Actual" },
          type: "select",
          label: "Periodo",
          opts: {
            style: 'float-label',
            path: "/admPeriod/get?pick=true"
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "Grado",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: "",
          type: "select",
          label: "Sección",
          parent: 'superSectionId',
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          },
          renderIf: (ctx) => { return  ctx.state.superSectionId }
        },
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => { return ctx.state.periodId || ctx.state.superSectionId },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.periodId = { value: r.data.periodId, label: r.data.periodName }
          r.data.gradeName = { value: r.data.gradeName, label: r.data.gradeName }
          r.data.sectionName = { value: r.data.sectionName, label: r.data.sectionName }
          r.data.userId = { value: r.data.userId, label: r.data.userName }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        delete v.flags
        delete v.btn1
        v.userId = v.userId.value
        return v
      },
      fields: [
        {
          col: 4,
          name: "periodId",
          value: "",
          type: "select",
          label: "Periodo",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admPeriod/get?pick=true"
          }
        },
        {
          col: 4,
          name: "gradeName",
          value: "",
          type: "select",
          label: "Grado",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          col: 4,
          name: "sectionName",
          value: "",
          type: "select",
          label: "Sección",
          rules: 'required',
          parent: 'gradeName',
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.form.gradeName }
          }
        },
        {
          col: 6,
          name: "userId",
          value: "",
          type: "select",
          label: "Alumno",
          rules: 'required',
          parent: 'sectionName',
          opts: {
            style: 'float-label',
            searchOnline: true,
            withImg: true,
            path: () => { return "/admStudent/get?pick=true" + (context.state.form.sectionName ? "&sectionId=" + context.state.form.sectionName : "") },
            setOutput: e => e
          }
        },
        {
          col: 6,
          name: "dateFrom",
          value: "",
          type: "date",
          label: "Fecha",
          rules: 'required',
          opts: {
              style: 'float-label',
          },
        },
        {
          col: 12,
          name: "tab-1",
          value: false,
          type: "collapsible",
          label: "Perfil psicopedagógico: cognitivo, comunicativo, emocional y autonomía",
          childs: [
            {
              col: 12,
              name: "note1",
              value: "",
              type: "editor",
              label: ""
            }
          ]
        },
        {
          col: 12,
          name: "tab-2",
          value: false,
          type: "collapsible",
          label: "Recomendaciones psicopedagógicas",
          childs: [
            {
              col: 12,
              name: "note2",
              value: "",
              type: "editor",
              label: ""
            }
          ]
        },
        {
          col: 12,
          name: "tab-3",
          value: false,
          type: "collapsible",
          label: "Recomendaciones por área académica",
          childs: [
            {
              col: 12,
              name: "note3",
              value: "",
              type: "editor",
              label: ""
            }
          ]
        },
        {
          col: 12,
          name: "tab-4",
          value: false,
          type: "collapsible",
          label: "Recomendaciones por perfil",
          childs: [
            {
              col: 12,
              name: "note4",
              value: "",
              type: "editor",
              label: ""
            }
          ]
        },
        {
          col: 4,
          name: "flag1",
          value: false,
          type: "switch",
          label: "AD"
        },
        {
          col: 8,
          name: "flag2",
          value: false,
          type: "switch",
          label: "I"
        },

        {
          col: 4,
          colxs: 4,
          name: "file1",
          value: "",
          type: "dropzone",
          label: "Adjunto 1",
          opts: {
            path: ()=> "admTracking/file"
          }
        },
        {
          col: 4,
          colxs: 4,
          name: "file2",
          value: "",
          type: "dropzone",
          label: "Adjunto 2",
          opts: {
            path: ()=> "admTracking/file"
          }
        },
        {
          col: 4,
          colxs: 4,
          name: "file3",
          value: "",
          type: "dropzone",
          label: "Adjunto 3",
          opts: {
            path: ()=> "admTracking/file"
          }
        },
        {
          col: 4,
          name: "btn1",
          type: "button",
          label: "Ver Citas",
          onClick: (ctx) => {
            ctx.toogleSubGrid(0)
          },
          renderIf: (ctx) => { return  context.state.idItemSelected }
        },
        {
          col: 4,
          label: "Descargar PDF",
          name: "Descargar PDF",
          value: "commitment",
          type: "button",
          onClick: () => {
            context.props.setLoader(true)
            _axios
              .get('admTracking/pdf/' + context.state.idItemSelected)
              .then(r => {
                if (r.status >= 0) {
                  window.URL = window.URL || window.webkitURL;
                  var xhr = new XMLHttpRequest(), a = document.createElement('a'), file;
                  xhr.open('GET', r.data.url, true);
                  xhr.responseType = 'blob';
                  xhr.onload = function () {
                    file = new Blob([xhr.response], { type : 'application/octet-stream' });
                    a.href = window.URL.createObjectURL(file);
                    a.download = r.data.filename;  
                    a.click();
                  };
                  xhr.send();
                }
                NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                context.props.setLoader(false)
              }).catch(e => {
                context.props.setLoader(false)
              })
          },
          renderIf: () => { return context.state.idItemSelected },
        },
        {
          col: 12,
          name: "bookings",
          value: null,
          type: "hidden",
          label: ""
        },
        {
          col: 12,
          name: "userName",
          value: "",
          type: "hidden",
          label: ""
        }
      ],
      subGrids: [
        {
          name: (ctx) => { return 'CITAS CON: ' + ctx.state.userName },
          module: 'admBookingList',
          filterBy: (ctx) => { return { userId: ctx.state.userId.value, userName: ctx.state.userId.label, IN: ctx.state.bookings?JSON.stringify(ctx.state.bookings):"[]" } }
        }
      ]
    },

    columns: [
      {
        Header: "ID",
        accessor: "ID"
      },
      {
        Header: "Alumno",
        accessor: "user"
      },
      {
        Header: "Grado",
        accessor: "grado"
      },
      {
        Header: "Fecha",
        accessor: "dateFrom",
        isDate: true
      },
      {
        Header: "Registrado por",
        accessor: "createdByName"
      }
    ]
  }
}